<template>
  <div class="overflow-x-auto h-full">
    <el-table
      ref="multipleTable"
      @selection-change="handleSelectionChange"
      :data="skeletonData"
      width="100%"
      height="100%"
      @cell-click="handleClick"
    >
      <el-table-column type="selection" width="55" align="center"/>
      <template v-for="column in columns">
        <el-table-column
          v-if="column.label === 'image'"
          :key="column.label"
          :prop="column.prop"
          label=""
          align="center"
          :width="column.Width"
          :min-width="column.minWidth"
        >
          <template slot-scope="scope">
            <figure class="overflow-hidden w-8 rounded-lg mx-auto" v-if="scope.row.unlink">
              <img class="h-8 w-8 object-cover" :src="require(`@/assets/img/${column.image}`)">
            </figure>
          </template>
        </el-table-column>
        <el-table-column
          v-else
          :sortable="column.sortable"
          :key="column.label"
          :prop="column.prop"
          :label="column.label"
          :width="column.Width"
          :min-width="column.minWidth"
        >
          <template v-if="isLoading">
            <span class="h-6 w-32 skeleton bg-secondary-100 block"></span>
          </template>
        </el-table-column>
      </template>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'table-base',
  props: {
    data: {
      type: [Array, Object],
      required: true
    },
    columns: {
      type: [Array, Object],
      required: true
    }
  },
  components: {},
  data: function () {
    return {
      isLoading: true,
      multipleSelection: [],
      skeletonData: [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }, { id: 7 }, { id: 8 }, { id: 9 }, { id: 10 }]
    }
  },
  watch: {
    data: function () {
      this.fakeLoading()
    }
  },
  mounted: function () {
    this.fakeLoading()
  },
  methods: {
    toggleSelection: function (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange: function (val) {
      this.multipleSelection = val
      this.$emit('selected', val)
    },
    handleClick: function (row, cell) {
      // if (cell.property === 'switch' || cell.property === 'actions' || cell.property === 'id') return
      if (cell.property === 'image') {
        this.$emit('imageClick', row)
        return
      }
      this.$emit('open', row.id)
    },
    fakeLoading: function () {
      setTimeout(() => {
        this.isLoading = false
        this.skeletonData = this.data
      }, 3000)
    }
  }
}
</script>

<style lang="scss" scoped>
table {
  table-layout: fixed !important;
  border-collapse: collapse !important;
}
.skeleton {
    position: relative;
    overflow: hidden;
    background-color: #e2e8f0;
    &::after {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      transform: translateX(-100%);
      background-image: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0,
        rgba(255, 255, 255, 0.2) 20%,
        rgba(255, 255, 255, 0.5) 60%,
        rgba(255, 255, 255, 0)
      );
      animation: shimmer 2s infinite;
      content: "";
    }
  }
  .dark .skeleton {
    @apply bg-darkblue;
    &::after {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      transform: translateX(-100%);
      background-image: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0,
        rgba(255, 255, 255, 0.03) 20%,
        rgba(255, 255, 255, 0.1) 60%,
        rgba(255, 255, 255, 0)
      );
      animation: shimmer 2s infinite;
      content: "";
    }
  }
  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
</style>
